export class ProductFormVariantSelect {
    constructor(product_json, section_id, enable_history) {
        this.product_json = product_json;
        this.product_id = this.product_json.id;
        this.section_id = section_id;
        this.enable_history = enable_history;
        this.stock_rules = {};
        this.master_select = null;
        this.product_form = null;
        this.quantity_selector = null;
        this.master_select_prefix = 'product-id';
        this.radio = '.option-radios-wrapper input[type=radio]';
        this.form = "form.main-product-form";
        this.selects = ".selector-wrapper";

        this.init();
    }

    init() {
        this.master_select = document.querySelector('#' + this.master_select_prefix + '-' + this.section_id + '-' + this.product_id);
        this.product_form = this.master_select.closest(this.form);
        this.variant_prices = Array.from(this.product_form.querySelectorAll('.variant-price-wrapper'));
        this.selected_color = this.product_form.querySelector('[data-color]');
        this.selected_size = this.product_form.querySelector('[data-size]');
        this.quantity_selector = this.product_form.querySelector('[quantity-select]');
        this.subtotal_el = this.product_form.querySelector('[product-sub-total]');
        this.maxtotal_el = this.product_form.querySelector('[product-max-total]');
        this.savingtotal_el = this.product_form.querySelector('[product-saving-total]');
        this.add_to_cart = this.product_form.querySelector('[add-to-cart]');
        this.add_to_cart_label = this.product_form.querySelector('[add-to-cart-label]');
        this.gallery_slides = document.querySelectorAll("[main-gallery] .main-swiper-slide");
        this.text_add_to_cart = this.product_form.dataset.addToCart;
        this.text_sold_out = this.product_form.dataset.soldOut;
        this.coming_soon_text = this.product_form.dataset.comingSoon;
        this.text_unavailable = this.product_form.dataset.unavailable;
        this.money_format = this.product_form.dataset.moneyFormat;
        this.chevron = this.product_form.querySelector('[select-chevron]');
        this.sticky_atc = this.product_form.querySelector('.sticky-add-to-cart');
        this.stockRules();
        this.shopifyOptionSelect();
        this.radiosOnChange();
        this.handleStickyATC();
    }

    unavailableVariants() {
        const master_select_options = this.master_select.querySelectorAll('option');
        const oos_text = this.master_select.dataset.oosText;
        if (master_select_options.length === 0) {
            console.error("Master select options not found.");
            return;
        }
        master_select_options.forEach((option) => {
            if (option.dataset.availability === "false") {
                const option1 = option.dataset.option;
                // Add unavailable class to radio buttons
                const oos_radio = this.product_form.querySelector(this.radio + `[data-value="${option1}"]`);
                if (oos_radio) {
                    oos_radio.classList.add('unavailable');
                }
                // Add unavailable class to select options
                const oos_option = this.product_form.querySelector(`.single-option-selector option[value="${option1}"]`);
                if (oos_option && oos_text && oos_option.classList.contains('unavailable') === false) {
                    const oos_option_html = oos_option.innerHTML;
                    oos_option.classList.add('unavailable');
                    oos_option.innerHTML = `${oos_option_html} - ${oos_text}`;
                }
            }
        });
    }


    stockRules() {
        const select_options = this.master_select.querySelectorAll('option');
        if (select_options.length === 0) {
            console.error("Select options not found.");
            return;
        }
        select_options.forEach((option) => {
            if (option.dataset.inventoryManagement === "shopify" && option.dataset.inventoryPolicy === "deny") {
                this.stock_rules[option.value] = option.dataset.inventoryQuantity;
            } else {
                this.stock_rules[option.value] = Number.MAX_SAFE_INTEGER;
            }
        });
    }

    flipChevron() {
        const select_wrappers = this.product_form.querySelectorAll('.selector-wrapper');
        select_wrappers.forEach((wrapper) => {

            const selectElement = wrapper.querySelector('select');
            const chevron = wrapper.querySelector('[select-chevron]');

            const rotateChevron = () => {
                chevron.classList.add('active');
            };

            const resetChevron = () => {
                chevron.classList.remove('active');
            };

            selectElement.addEventListener('focus', rotateChevron);

            selectElement.addEventListener('change', resetChevron);

            selectElement.addEventListener('blur', resetChevron);
        });
    }

    setVariantPrice(variant) {
        // if (!this.subtotal_el) {
        //     return;
        // }
        // const money_format = this.subtotal_el.dataset.moneyFormat;
        // this.subtotal_el.setAttribute("data-variant-price", variant.price);
        // this.subtotal_el.innerHTML = Shopify.formatMoney(variant.price, money_format);

        const next_price_el = this.variant_prices.find(item => item.dataset.variantId == variant.id);
        const prev_price_el = this.variant_prices.find(item => !item.classList.contains('hidden'));

        prev_price_el?.classList.add("hidden");
        next_price_el?.classList.remove("hidden");
    }

    setSubmitButtonState(availability) {
        const submit = this.add_to_cart;
        const sticky_submit = this.sticky_atc;
        const label = this.add_to_cart_label;
        const ADD_TO_CART = this.text_add_to_cart;
        const SOLD_OUT = this.text_sold_out;
        const UNAVAILABLE = this.text_unavailable;
        const COMING_SOON = this.product_form.dataset.comingSoon;
        if (!submit) {
            console.error("Submit button not found.");
            return;
        }
        if (availability === true || availability === "true") {
            submit.value = ADD_TO_CART;
            submit.innerHTML = ADD_TO_CART;
            submit.removeAttribute("disabled");
            label.classList.remove("disabled");


            if ( sticky_submit ) {
                sticky_submit.innerHTML = ADD_TO_CART;
                sticky_submit.classList.remove("disabled");
            }

        } else if (availability === "unavailable") {
            submit.value = UNAVAILABLE;
            submit.innerHTML = UNAVAILABLE;
            submit.setAttribute("disabled", "");
            label.classList.add("disabled");

            if ( sticky_submit ) {
                sticky_submit.innerHTML = UNAVAILABLE;
                sticky_submit.classList.add("disabled");
            }

        } else if (availability === "coming_soon") {
            submit.value = COMING_SOON;
            submit.innerHTML = COMING_SOON;
            submit.setAttribute("disabled", "");
            label.classList.add("disabled");

            if ( sticky_submit ) {
                sticky_submit.innerHTML = COMING_SOON;
                sticky_submit.classList.add("disabled");
            }
        } else {
            submit.value = SOLD_OUT;
            submit.innerHTML = SOLD_OUT;
            submit.setAttribute("disabled", "");
            label.classList.add("disabled");

            if ( sticky_submit ) {
                sticky_submit.innerHTML = SOLD_OUT;
                sticky_submit.classList.add("disabled");
            }
        }
    }

    setQuantityVisibility(availability) {
        if (!this.quantity_selector) {
            return;
        }
        const quantity_wrapper = this.quantity_selector.closest('.quantity-wrapper');
        if (!quantity_wrapper) {
            return;
        }

        if (availability === "unavailable" || availability === false || availability === "sold_out" || availability === "coming_soon") {
            quantity_wrapper.style.display = "none";
        } else {
            quantity_wrapper.style.display = "flex";
        }
    }

    setQuantityStock(variant) {
        if (!this.quantity_selector) {
            return;
        }
        const quantity_input = this.quantity_selector.querySelector('input');
        if (!quantity_input) {
            console.error("Quantity input not found.");
            return;
        }

        const max_stock = this.stock_rules[variant.id];
        quantity_input.max = max_stock;
    }

    setQuantityRules(quantity_rule) {
        if (!quantity_rule) {
            return;
        }
        if (!this.quantity_selector) {
            return;
        }
        const quantity_input = this.quantity_selector.querySelector('input');
        if (!quantity_input) {
            console.error("Quantity input not found.");
            return;
        }

        const quantity_number_el = this.quantity_selector.querySelector('[quantity]');
        if (!quantity_number_el) {
            console.error("Quantity number element not found.");
            return;
        }

        if (quantity_rule.min) {
            quantity_input.min = quantity_input.value = quantity_number_el.innerHTML = quantity_rule.min;
        } else {
            quantity_input.min = quantity_input.value = quantity_number_el.innerHTML = 1;
        }
        if (quantity_rule.max) {
            quantity_input.max = quantity_rule.max;
        }
        if (quantity_rule.step) {
            quantity_input.step = quantity_rule.step;
        }
    }

    checkRadios(selector) {
        const selects = selector.selectors;
        const radios = this.product_form.querySelectorAll(this.radio);
        if (radios.length > 1) {
            selects.forEach((select) => {
                const select_index = select.index + 1;
                const selected_option_index = select.element.selectedIndex;
                const radio_to_check = this.product_form.querySelector(`.radio-option[data-option="${select_index}"] input[data-index="${selected_option_index}"]`);
                if (radio_to_check) {
                    radio_to_check.checked = true;
                    radio_to_check.setAttribute("checked", true);
                } else {
                    console.log(`Radio button for select ${select_index} not found.`);
                }
            });
        }
    }

    radiosOnChange() {
        const radios = this.product_form.querySelectorAll(this.radio);
        if (radios.length > 0) {
            radios.forEach(radio => {
                radio.addEventListener('change', () => {
                    const option_index = radio.closest('.radio-option').dataset.option;
                    const option_value = radio.value;
                    const select = this.product_form.querySelector(`select[data-option='option${option_index}']`);
                    if (select) {
                        select.value = option_value;
                        // trigger change event
                        const event = new Event('change');
                        select.dispatchEvent(event);
                    } else {
                        console.error(`Select element for radio ${option_index} not found.`);
                    }

                    if(radio.name.includes('Color') && this.selected_color) {
                        this.selected_color.innerHTML = radio.value;
                    } else if (radio.name.includes('Size') && this.selected_size) {
                        this.selected_size.innerHTML = radio.value;
                    }
                });
            });
        }
    }

    variantImageChange(variant) {
        if (!this.gallery_slides) {
            return;
        }
        // Loop through all gallery slides and get comma separate list of idfs from image slide - data-id
        this.gallery_slides.forEach((slide) => {
            const slide_id = slide.dataset.id;
            const slide_index = slide.dataset.index;

            if (!slide_id) {
                console.log("Slide id not found.");
                return;
            }
            const slide_variant_ids = slide_id.split(',');
            // If variant id is in slide_variant_ids, show slide
            if (slide_variant_ids.includes(variant.id.toString())) {
                console.log("Has variant id", slide_variant_ids);
                mainSwiper.slideTo(slide_index,500);
            }
        });

    }

    addOptionLabels(selector) {
        const selects = this.product_form.querySelectorAll(this.selects);
        selects.forEach((select,i) => {
            const name = selector.selectors[i].name;
            const label = select.querySelector('label');
            if (!label) {
                const new_label = document.createElement('label');
                new_label.innerHTML = name;
                new_label.setAttribute('for', select.id);
                select.prepend(new_label);
            }
        });
    }


    selectCallback(variant, selector) {
        // AVAILABILITY STATES
        const AVAILABILITY_AVAILABLE = true;
        const AVAILABILITY_UNAVAILABLE = "unavailable";
        const AVAILABILITY_SOLD_OUT = "sold_out";
        const AVAILABILITY_COMING_SOON = "coming_soon";

        const selector_wrappers = this.product_form.querySelectorAll('.selector-wrapper');
        selector_wrappers.forEach((selector_wrapper) => {
            const chevron = selector_wrapper.querySelector('[select-chevron]');
            if (chevron) {
                return;
            }
            const chevronClone = this.chevron.cloneNode(true);
            selector_wrapper.appendChild(chevronClone);
        });

        this.flipChevron();

        // SUBMIT BUTTON STATE - Changes submit button text and state based on variant availability
        if (!variant) {
            this.setSubmitButtonState(AVAILABILITY_UNAVAILABLE);
            this.setQuantityVisibility(AVAILABILITY_UNAVAILABLE);
            return;
        }

        this.coming_soon = false;
        if (this.coming_soon_text != undefined && this.coming_soon_text != null && this.coming_soon_text != "") {
            this.coming_soon = true;
            console.log("Coming soon text found. ", this.coming_soon_text);
        }

        if (this.coming_soon) {
            // Prioritize "Coming Soon" state if the flag is set
            this.setSubmitButtonState(AVAILABILITY_COMING_SOON);
            this.setQuantityVisibility(AVAILABILITY_SOLD_OUT);
        } else if (variant.available) {
            this.setSubmitButtonState(AVAILABILITY_AVAILABLE);
            this.setQuantityVisibility(AVAILABILITY_AVAILABLE);
        } else {
            this.setSubmitButtonState(AVAILABILITY_SOLD_OUT);
            this.setQuantityVisibility(AVAILABILITY_SOLD_OUT);
        }

        // CHECK RADIOS - checks radio buttons based on option select element
        this.checkRadios(selector);
        // QUANTITY RULES IF PRESENT - Adds min and max attributes to quantity input
        this.setQuantityStock(variant);
        // SET PRICE - Sets price based on variant
        this.setQuantityRules(variant.quantity_rule);
        // SET STOCK - Sets max stock attribute to quantity input
        this.setVariantPrice(variant);
        // SET IMAGE - Changes main image based on variant
        this.variantImageChange(variant);
        // Add label to selected options
        this.addOptionLabels(selector);
        // Set unavailable radio buttons
        this.unavailableVariants(variant,selector);
    }

    shopifyOptionSelect() {
        new Shopify.OptionSelectors(this.master_select_prefix + '-' + this.section_id + '-' + this.product_id, {
            product: this.product_json,
            onVariantSelected: this.selectCallback.bind(this),
            enableHistoryState: this.enable_history
        });
    }


    handleStickyATC() {
        const sticky_submit = this.sticky_atc;
        const actionContainer = this.product_form.querySelector('.product-submit-wrapper');

        if ( sticky_submit && actionContainer ) {


            sticky_submit.addEventListener('click', () => {
                actionContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
            });

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // If the element is within the specified rootMargin, remove the class
                        sticky_submit.classList.remove('visible');
                    } else {
                        // If the element is outside the specified rootMargin, add the class
                        sticky_submit.classList.add('visible');
                    }
                });
            }, {
                rootMargin: '-20% 0px -10% 0px'
            });
            observer.observe(actionContainer);
        }
    }
}